<template>
  <div>


    <CRow>
      <CCol col="6">
        <CCard>
          <CCardHeader>
            <CRow>
              <CCol col="8" style="text-align: start ;">

                <strong >سطوح دسترسی</strong>

              </CCol>
              <CCol col="4" style="text-align: end">

                <CButton
                    class="mr-1"
                    v-if="status_form_role==0" @click="insert_data_role()"
                    size="sm"
                    color="secondary"
                >{{ $t("buttons.submit") }}
                </CButton>
                <CButton
                    class="mr-1"
                    v-if="status_form_role!=0" @click="insert_data_role()"
                    size="sm"
                    color="secondary"
                >{{ $t("buttons.edit") }}
                </CButton>


              </CCol>
            </CRow>

          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol col="4">
                <CSelect
                    label="والد"
                    horizontal

                    :options="all_role_groups"
                    :value.sync="selected_parent"/>
              </CCol>
              <CCol col="4">
                <CInput
                    label="کد"
                    horizontal
                    v-model="role_code"
                />
              </CCol>
              <CCol col="4">
                <CInput
                    :label="$t('tables.name')"
                    horizontal
                    v-model="role_name"
                />
              </CCol>
            </CRow>


          </CCardBody>

        </CCard>
        <CCardBody>
          <CRow>
            <CCol col="6">
              <CSelect
                  :label="$t('components.roleGroup')"
                  :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"

                  :options="role_groups"
                  :value.sync="selected_role_groups"/>
            </CCol>
          </CRow>
          <CDataTable
              :items="filtered_role_items"
              :fields="fields_role"
              column-filter
              style="height: 200px;overflow: auto"
              hover
              :items-per-page="5"
              sorter
          >
            <template #name="{item}">

              <td>
                <p >{{ item.operationName }}</p>

              </td>

            </template>
            <template #role="{item}">

              <td>
                <CIcon @click.native="item.isHidden =1"
                       v-if="item.isHidden==0" class="text-success" name="cil-check"/>
                <CIcon @click.native="item.isHidden =0" v-else name="cil-check"/>

              </td>

            </template>
            <template #operation="{item,index}">
              <td>


                <CIcon  @click.native="edit_item_role(item)" class="text-primary mr-2" size="sm" name="cil-pencil"/>

<!--                <CIcon @click.native="delete_item_dialog(item)" size="sm"  class=" mr-2 text-danger" name="cilTrash"/>-->
              </td>
            </template>

          </CDataTable>
        </CCardBody>

      </CCol>

      <CCol col="6">
        <CCard>
          <CCardHeader>
            <CRow>
              <CCol col="8" style="text-align: start ;">

                <strong >گروه های دسترسی</strong>

              </CCol>
              <CCol col="4" style="text-align: end">

                <CButton
                        class="mr-1 ml-1"
                        v-if="status_form_parent==0" @click="insert_data_parent()"
                    size="sm"
                    color="secondary"
                >{{ $t("buttons.submit") }}
                </CButton>
                <CButton
                    class="mr-1"
                    v-if="status_form_parent!=0" @click="insert_data_parent()"
                    size="sm"
                    color="secondary"
                >{{ $t("buttons.edit") }}
                </CButton>

              </CCol>
            </CRow>

          </CCardHeader>
          <CCardBody>
            <CRow>

              <CCol col="6">
                <CInput
                    label="نام والد"

                    v-model="parent_name"
                />
              </CCol>
            </CRow>


          </CCardBody>
          <CDataTable
              :items="all_role_groups"
              :fields="fields_parent"
              column-filter
              style="height: 200px;overflow: auto"
              hover
              :items-per-page="5"
              sorter
          >
            <template #name="{item}">

              <td>
                <p >{{ item.operationName }}</p>

              </td>

            </template>
            <template #role="{item}">

              <td>
                <CIcon @click.native="item.isHidden =1"
                       v-if="item.isHidden==0" class="text-success" name="cil-check"/>
                <CIcon @click.native="item.isHidden =0" v-else name="cil-check"/>

              </td>

            </template>
            <template #operation="{item,index}">
              <td>


                <CIcon  @click.native="edit_item_parent(item)" class="text-primary mr-2" size="sm" name="cil-pencil"/>

<!--                <CIcon @click.native="delete_item_dialog(item)" size="sm"  class=" mr-2 text-danger" name="cilTrash"/>-->
              </td>
            </template>

          </CDataTable>

        </CCard>

      </CCol>
    </CRow>
    <CRow>
      <CCol col="12">

      </CCol>

    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';

var items = [];
var items_role = [];


export default {
  name: 'Login',
  data() {
    return {
      confirm_delete_name:"confirm"+new Date().getTime()+"_"+this.$vnode.tag,

      selected_parent:0,
      status_form_role:0,
      status_form_parent:0,
      role_code:'',
      role_name:'',
      parent_name:'',
      role_groups:[],
      all_role_groups:[],
      selected_role_groups: 0,
      items: items.map((item, row_id) => {
        return {...item, row_id}
      }),
      role_items: [],
      filtered_role_items: [],
      fields: [],
      fields_role: [
        {key: 'operationName', label: this.$t('tables.name'), _style: 'width:20%'},
        {key: 'operationCode', label: "کد", _style: 'width:20%'},
        {key: 'role', filter: false, label: this.$t('tables.status'), _style: 'width:20%'},
        {key: 'operation', filter: false, label: "عملیات", _style: 'width:20%'},
      ],
      fields_parent: [
        {key: 'label', label: this.$t('tables.name'), _style: 'width:20%'},
        {key: 'role', filter: false, label: this.$t('tables.status'), _style: 'width:20%'},
        {key: 'operation', filter: false, label: "عملیات", _style: 'width:20%'},

      ],
      role_checkbox_items: [],
      details: [],
      collapseDuration: 0,
      status_form: 0
    }
  }, mounted() {
    this.$root.root_validate_errors = [];
    this.get_roles();
    this.get_groups();

    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  }, watch: {
    'selected_role_groups': function () {
      if (this.selected_role_groups == 0) {
        this.filtered_role_items = this.role_items;
      } else {
        this.filtered_role_items = this.role_items.filter(item => item.parentId == this.selected_role_groups);

      }
    }
  },
  methods: {

    get_group_name(index){
      return "group_"+index
    },
    get_group_header(index){
      return "group_"+index+"-header"
    },
    edit_item_role(item) {
      this.role_code = item.operationCode;
      this.role_name = item.operationName;
      this.status_form_role = item.id;

    },
    edit_item_parent(item) {
      this.parent_name = item.label;
      this.status_form_parent = item.value;

    }, emptyList() {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.name = '';
      this.role_checkbox_items = [];
      this.description = '';
      this.previewImage = '';
      this.status_form = 0;

      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    },
    get_roles() {
      var self = this;

      const formData = new FormData();

      axios.post('GetOperationSystems', formData, {}).then(function (response) {

        var content = response.data;

        // items = content_cats.orders;
        self.role_items = content.data.map((item, row_id) => {
          return {...item, row_id}
        });
        self.filtered_role_items = self.role_items
      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_groups() {
      var self = this;

      const formData = new FormData();

      axios.post('GetOperationParents', formData, {}).then(function (response) {

        var content = response.data;

        // items = content_cats.orders;
        // self.role_groups = content.data.map((item, row_id) => {
        //   return {...item, row_id}
        // });
        self.role_groups = [];
        self.role_groups = content.data.map(({id, title}) => ({label: title, value: id}));
        self.role_groups.splice(0, 0, {label: self.$t('all'), value: 0});

        self.all_role_groups = [];
        self.all_role_groups = content.data.map(({id, title,isHidden}) => ({label: title, value: id,isHidden:isHidden}));

        self.selected_parent = self.all_role_groups[0].value

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_role_info() {
      var self = this;

      const formData = new FormData();
      formData.append("id", self.status_form);
      axios.post('GetGroupTitleById', formData, {}).then(function (response) {

        var content = response.data;
        self.role_checkbox_items = []

        self.name = content.data.groupInfo.groupName;
        content.data.operationSystems.forEach((val) => {
          self.role_checkbox_items.push(val.rolId);
        });
        //  self.role_checkbox_items =  content.data.groupInfo.groupName;

        // items = content_cats.orders;

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    edit_data(group_item) {

      let self = this;

      const formData = new FormData();
      let url;

      url = "EditGroupTitle";
      formData.append('id', group_item.id)

      group_item.rols.forEach((val) => {
        // OperationSystems.push({val});
        formData.append('OperationSystems', val);

      });
      // console.log("json group"+ JSON.stringify(person));
      formData.append('groupName', group_item.groupName);
      // formData.append('OperationSystems',  OperationSystems);
      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res)

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    insert_data_role() {

      let self = this;

      const formData = new FormData();
      let url;
      if (this.status_form == 0) {
        url = "AddOperationSystem";
      } else {
        url = "EditOperationSystem";
        formData.append('id', this.status_form_role)

      }

      formData.append('ParentId', self.selected_parent);
      formData.append('OperationCode', self.role_code);
      formData.append('OperationName', self.role_name);
      formData.append('IsHidden', 0);

      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res)
        self.status_form_role = 0;
        self.role_code = '';
        self.role_name = '';
        // self.description = '';
        // self.previewImage = '';
        self.get_lists();


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    insert_data_parent() {

      let self = this;

      const formData = new FormData();
      let url;
      if (this.status_form == 0) {
        url = "AddOperationParent";
      } else {
        url = "EditOperationParent";
        formData.append('id', this.status_form_role)

      }

      formData.append('Title', self.parent_name);
      formData.append('IsHidden', 0);

      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res)
        self.status_form_role = 0;
        self.role_code = '';
        self.role_name = '';
        // self.description = '';
        // self.previewImage = '';
        self.get_lists();


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    delete_item_dialog(item) {
      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], this.confirm_delete_name);

      this.status_form = this.items[item.row_id].id;

    },
    delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "DeleteGroupTitle";


      formData.append('id', this.status_form);

      axios.post(url, formData, {}).then((res) => {
        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;

        self.get_lists();


      })
          .catch(function (error) {

            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
  }
}

</script>
